import React from 'react';
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';
import ImageBannerCta from '../cta/ImageBannerCta';
import FavouriteServices from '../general/FavoriteServices';
// Data

function AboutPageMainContainer() {
  return (
    <main role='main' className='grid gap-16 pt-16'>
      <FavouriteServices />
      
      {/* Gallery */}
      <SmallGalleryComponent />

      {/* Cta */}
      <ImageBannerCta />
    </main>
  );
}

export default AboutPageMainContainer;
